var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgArrowupsvg = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 10,
    viewBox: "0 0 18 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.501256 9.601C1.11226 10.212 1.49126 10.068 2.03426 9.525L9.02026 2.539L16.0593 9.604C16.5553 10.101 16.9413 10.153 17.4813 9.614C18.0213 9.074 17.9983 8.715 17.4863 8.204L10.4343 1.124L9.95426 0.644C9.56126 0.251 9.33826 0 9.02026 0C8.72526 0 8.50026 0.215 8.15826 0.559L7.60326 1.122L0.584256 8.142C0.0392557 8.685 -0.0687443 9.031 0.501256 9.601Z",
    fill: "#1D6460"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgArrowupsvg);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/arrowupsvg.6bb1d077763dc09ae19345a5771e81ec.svg";